export interface IVerifyCardResponse {
    merchantName: string
    description: string
    amount: number,
    otherUrl: string,
    resultRedirectUrl: string,
    cancelUrl: string,
    tempToken: string,
    idHostedPaymentPageRequest: number,
    displayCreditCard: boolean,
    displayAch: boolean,
    expiration: Date,
    otherInfo: string,
    merchantGuid: string,
    used: boolean,
    tenderTypeOptions: [],
    expired: boolean,
    passThrough: boolean,
    verify: {
        guid: string,
        status: string,
        timeStamp: Date,
        deviceGuid: string,
        card: {
            first6: string,
            first4: string,
            last4: string,
            cardHolderName: string,
            cardType: string,
            expirationDate: string,
            guid: string,
            customer: {
                guid: string,
                email: string
            }
        },
        walletProvider: number,
        cvvVerificationCode: string,
        processorStatusCode: number,
        wasProcessed: boolean,
        passThrough: boolean
    }
}

export interface IDataType {
    data: IVerifyCardResponse,
    type: 'error' | 'validation' | 'success',
    msg: string
}

export interface IConnexPayConfiguration {
    acceptHeader: string
    publicKey: string
    deviceGuid: string
    bookingid: string
    amount: number
    expiration: string
}

export interface IBrowserData {
    acceptanceHeader: string;
    colorDepth: number;
    javaEnabled: boolean;
    screenHeight: number;
    screenWidth: number;
    timeZoneOffset: number;
    language: string;
    redirectURL: string;
    userAgentHeader: string;
}



export default class ConnexPayService {
    constructor(             
    ) {}


    public getBrowserInfo(acceptHeader:string,redirectURL:string):IBrowserData {
        return  {
            acceptanceHeader: acceptHeader,
            colorDepth: [48, 32, 24, 16, 15, 8, 4, 2, 1].find(depth => depth <= window.screen.colorDepth) || 24, // only specific color depths are supported by the 3DS2 standard
            javaEnabled: false,
            screenHeight: window.screen.height,
            screenWidth: window.screen.width,
            timeZoneOffset: new Date().getTimezoneOffset(),
            language: navigator.language,
            redirectURL: redirectURL,
            userAgentHeader: navigator.userAgent
        }
    }

   
}